<script setup>
import { ref, computed } from "vue";

// Valor de búsqueda y listado de ciudades
const search = ref("");
const ingresoCiudadManual = ref(false);
const citiesList = [
  { label: "Buenos Aires - Buenos Aires (C1001)", value: "C1001" },
  { label: "Córdoba - Córdoba (X5000)", value: "X5000" },
  { label: "Rosario - Santa Fe (S2000)", value: "S2000" },
  { label: "Mendoza - Mendoza (M5500)", value: "M5500" },
  { label: "La Plata - Buenos Aires (B1900)", value: "B1900" },
];

// Filtrar ciudades según el valor de búsqueda
const filteredCities = computed(() => {
  const query = search.value.toLowerCase();
  return citiesList.filter(
    (city) =>
      city.label.toLowerCase().includes(query) ||
      city.value.toLowerCase().includes(query)
  );
});

// Seleccionar una ciudad y actualizar el valor de búsqueda
const selectCity = (city) => {
  search.value = city.label;
};

// Limpiar búsqueda si se cambia el modo manual
const clearSearch = () => {
  search.value = "";
};
</script>

<template>
  <div class="relative">
    <!-- Campo de entrada para búsqueda de ciudad -->
    <input
      type="text"
      v-model="search"
      placeholder="Selecciona tu ciudad"
      class="w-full px-3 py-2 border rounded focus:outline-none"
    />

    <!-- Lista de ciudades filtradas -->
    <ul
      v-if="filteredCities.length && !ingresoCiudadManual"
      class="absolute bg-white border rounded mt-1 w-full max-h-60 overflow-y-auto z-10"
    >
      <li
        v-for="city in filteredCities"
        :key="city.value"
        @click="selectCity(city)"
        class="px-3 py-2 cursor-pointer hover:bg-blue-100"
      >
        {{ city.label }}
      </li>
    </ul>

    <!-- Opción para ingresar ciudad manualmente -->
    <p
      v-if="!ingresoCiudadManual"
      @click="
        ingresoCiudadManual = true;
        clearSearch();
      "
      class="text-blue-500 text-sm cursor-pointer mt-2"
    >
      ¿No encontrás una ciudad cerca? Ingresar manualmente
    </p>

    <!-- Campo de entrada manual de ciudad -->
    <input
      v-if="ingresoCiudadManual"
      type="text"
      v-model="search"
      placeholder="Ingresá tu ciudad"
      class="w-full mt-2 px-3 py-2 border rounded focus:outline-none"
    />
  </div>
</template>

<style scoped>
/* Estilos adicionales para la lista desplegable */
.absolute {
  z-index: 10;
}
.formkit-option {
  padding: 0.5rem;
  cursor: pointer;
}
</style>
